import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { NdisStandardsPage } from '@/features/ndis-standards'
import { requireActiveSubscription } from '@/lib/middleware'

const searchSchema = z.object({
  division: z.string().optional(),
  state: z.enum(['ready', 'in_progress', 'not_started']).optional(),
  id: z.string().optional(),
  from: z.string().optional(),
  obligation: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/compliance/standards')({
  beforeLoad: async () => requireActiveSubscription(),
  validateSearch: searchSchema,
  component: NdisStandardsPage,
})
